<script lang="ts">
	import { onMount, onDestroy, tick } from "svelte";
	import { fly } from "svelte/transition";
	import { goto, yyyy, zzzz } from "./store.svelte";
	import { slideDecks } from "./slides/slideData";
	import SlideShow from "./slides/SlideShow.svelte";

	let ready = $state(false);
	let showPicker = $state(false);

	let getSelectedDeck = () => {
		if (!yyyy.selectedSlide) return null;
		return slideDecks.find(d => d.slug === yyyy.selectedSlide) ?? null;
	};

	const goBack = () => {
		yyyy.selectedSlide = null;
		goto('/slides');
	};

	const handleKeydown = (e: KeyboardEvent) => {
		if (yyyy.selectedSlide) return;
		if (e.key === '/' && !showPicker) {
			const tag = (e.target as HTMLElement)?.tagName;
			if (tag === 'INPUT' || tag === 'TEXTAREA') return;
			e.preventDefault();
			showPicker = true;
		}
		if (e.key === 'Escape' && showPicker) {
			showPicker = false;
		}
	};

	const handleClick = (e: MouseEvent) => {
		if (!showPicker) return;
		const dialog = document.querySelector('.slides-picker');
		if (dialog && !dialog.contains(e.target as Node)) {
			showPicker = false;
		}
	};

	const pickDeck = (slug: string) => {
		showPicker = false;
		yyyy.selectedSlide = slug;
		history.pushState({ uri: `/slides/${slug}` }, "lvwr.io", `/slides/${slug}`);
	};

	onMount(() => {
		ready = true;
		yyyy.logo.usage = "logo";
		yyyy.slidesActive = true;
		zzzz.emit("slides-enter");
	});

	onDestroy(() => {
		yyyy.logo.time = 877.5;
		yyyy.logo.usage = "wait";
		yyyy.slidesActive = false;
		zzzz.emit("slides-leave");
	});
</script>

<svelte:window onkeydown={handleKeydown} onclick={handleClick} />

{#if ready}
	{#key yyyy.selectedSlide}
		{#if yyyy.selectedSlide}
			{@const deck = getSelectedDeck()}
			{#if deck}
				<div class="fullscreen-slide" transition:fly|local={{ y: 40, duration: 200 }}>
						<SlideShow {deck} embedded={false} />
				</div>
			{/if}
		{/if}
	{/key}
{/if}

{#if showPicker}
	<div class="picker-backdrop" transition:fly={{ y: 0, duration: 150 }}>
		<div class="slides-picker" transition:fly={{ y: -20, duration: 200 }}>
			{#each slideDecks as deck (deck.slug)}
				<button
					class="picker-item"
					onclick={() => pickDeck(deck.slug)}
				>
					<span class="picker-name">{deck.name}</span>
					<span class="picker-subtitle">{deck.subtitle}</span>
				</button>
			{/each}
		</div>
	</div>
{/if}

<style>
	.fullscreen-slide {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 9000;
		background: #fff;
	}

	.picker-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.slides-picker {
		background: rgba(26, 26, 46, 0.92);
		border: 1px solid rgba(232, 73, 28, 0.15);
		border-radius: 12px;
		padding: 8px;
		min-width: 360px;
		max-width: 480px;
		box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
		backdrop-filter: blur(12px);
	}

	.picker-item {
		display: block;
		width: 100%;
		background: transparent;
		border: none;
		border-radius: 8px;
		padding: 14px 18px;
		text-align: left;
		cursor: pointer;
		transition: background 0.15s;
	}

	.picker-item:hover {
		background: rgba(232, 73, 28, 0.1);
	}

	.picker-name {
		display: block;
		font-size: 1em;
		font-weight: 600;
		color: #e8e8f0;
	}

	.picker-subtitle {
		display: block;
		font-size: 0.8em;
		color: #9898b0;
		margin-top: 2px;
	}
</style>
